module.exports = __webpack_public_path__ + "static/media/home-care-card-3.89e1f60e.png";